export const REQUEST_STATE = 'REQUEST_STATE'
export const SET_ERROR = 'SET_ERROR'
export const SET_LOADING = 'SET_LOADING'

export const LOGOUT = 'LOGOUT'
export const CORE_GET_USERS_REQUEST = 'CORE_GET_USERS_REQUEST'
export const CORE_GET_USERS_SUCCESS = 'CORE_GET_USERS_SUCCESS'
export const CORE_GET_USERS_FAILURE = 'CORE_GET_USERS_FAILURE'

export const CORE_GET_USER_INFO_REQUEST = 'CORE_GET_USER_INFO_REQUEST'
export const CORE_GET_USER_INFO_SUCCESS = 'CORE_GET_USER_INFO_SUCCESS'
export const CORE_GET_USER_INFO_FAILURE = 'CORE_GET_USER_INFO_FAILURE'

export const CORE_CHANGE_USER_NPI_PERMIT_REQUEST = 'CORE_CHANGE_USER_NPI_PERMIT_REQUEST'
export const CORE_CHANGE_USER_NPI_PERMIT_SUCCESS = 'CORE_CHANGE_USER_NPI_PERMIT_SUCCESS'
export const CORE_CHANGE_USER_NPI_PERMIT_FAILURE = 'CORE_CHANGE_USER_NPI_PERMIT_FAILURE'

export const CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST = 'CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST'
export const CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS = 'CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS'
export const CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE = 'CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE'

//AUTH
export const CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST'
export const CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS'
export const CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE'

export const CORE_GET_REQUEST_INFO_REQUEST = "CORE_GET_REQUEST_INFO_REQUEST"
export const CORE_GET_REQUEST_INFO_SUCCESS = "CORE_GET_REQUEST_INFO_SUCCESS"
export const CORE_GET_REQUEST_INFO_FAILURE = "CORE_GET_REQUEST_INFO_FAILURE"

//  Drawing
export const CORE_LOAD_DRAWING_INFORMATION_REQUEST = "CORE_LOAD_DRAWING_INFORMATION_REQUEST"
export const CORE_LOAD_DRAWING_INFORMATION_SUCCESS = "CORE_LOAD_DRAWING_INFORMATION_SUCCESS"
export const CORE_LOAD_DRAWING_INFORMATION_FAILURE = "CORE_LOAD_DRAWING_INFORMATION_FAILURE"

export const CORE_SEARCH_DRAWING_REQUEST = "CORE_SEARCH_DRAWING_REQUEST"
export const CORE_SEARCH_DRAWING_SUCCESS = "CORE_SEARCH_DRAWING_SUCCESS"
export const CORE_SEARCH_DRAWING_FAILURE = "CORE_SEARCH_DRAWING_FAILURE"

export const CORE_CREATE_DRAWING_REQUEST = "CORE_CREATE_DRAWING_REQUEST"
export const CORE_CREATE_DRAWING_SUCCESS = "CORE_CREATE_DRAWING_SUCCESS"
export const CORE_CREATE_DRAWING_FAILURE = "CORE_CREATE_DRAWING_FAILURE"

export const CORE_UPDATE_DRAWING_INFO_REQUEST = "CORE_UPDATE_DRAWING_INFO_REQUEST"
export const CORE_UPDATE_DRAWING_INFO_SUCCESS = "CORE_UPDATE_DRAWING_INFO_SUCCESS"
export const CORE_UPDATE_DRAWING_INFO_FAILURE = "CORE_UPDATE_DRAWING_INFO_FAILURE"


// Master
export const CORE_LOAD_MASTER_DATA_REQUEST = 'CORE_LOAD_MASTER_DATA_REQUEST'
export const CORE_LOAD_MASTER_DATA_SUCCESS = 'CORE_LOAD_MASTER_DATA_SUCCESS'
export const CORE_LOAD_MASTER_DATA_FAILURE = 'CORE_LOAD_MASTER_DATA_FAILURE'

// Customer
export const CORE_LOAD_CUSTOMER_REQUEST = "CORE_LOAD_CUSTOMER_REQUEST"
export const CORE_LOAD_CUSTOMER_SUCCESS = "CORE_LOAD_CUSTOMER_SUCCESS"
export const CORE_LOAD_CUSTOMER_FAILURE = "CORE_LOAD_CUSTOMER_FAILURE"

export const CORE_UPDATE_CUSTOMER_FROM_AX_REQUEST = "CORE_UPDATE_CUSTOMER_FROM_AX_REQUEST"
export const CORE_UPDATE_CUSTOMER_FROM_AX_SUCCESS = "CORE_UPDATE_CUSTOMER_FROM_AX_SUCCESS"
export const CORE_UPDATE_CUSTOMER_FROM_AX_FAILURE = "CORE_UPDATE_CUSTOMER_FROM_AX_FAILURE"

export const CORE_CREATE_CUSTOMER_REQUEST = "CORE_CREATE_CUSTOMER_REQUEST"
export const CORE_CREATE_CUSTOMER_SUCCESS = "CORE_CREATE_CUSTOMER_SUCCESS"
export const CORE_CREATE_CUSTOMER_FAILURE = "CORE_CREATE_CUSTOMER_FAILURE"


// Item
export const CORE_LOAD_ITEM_INFORMATION_REQUEST = 'CORE_LOAD_ITEM_INFORMATION_REQUEST'
export const CORE_LOAD_ITEM_INFORMATION_SUCCESS = 'CORE_LOAD_ITEM_INFORMATION_SUCCESS'
export const CORE_LOAD_ITEM_INFORMATION_FAILURE = 'CORE_LOAD_ITEM_INFORMATION_FAILURE'

export const CORE_SAVE_ITEM_REQUEST = 'CORE_SAVE_ITEM_REQUEST'
export const CORE_SAVE_ITEM_SUCCESS = 'CORE_SAVE_ITEM_SUCCESS'
export const CORE_SAVE_ITEM_FAILURE = 'CORE_SAVE_ITEM_FAILURE'

export const CORE_SUBMIT_ITEM_REQUEST = 'CORE_SUBMIT_ITEM_REQUEST'
export const CORE_SUBMIT_ITEM_SUCCESS = 'CORE_SUBMIT_ITEM_SUCCESS'
export const CORE_SUBMIT_ITEM_FAILURE = 'CORE_SUBMIT_ITEM_FAILURE'

export const CORE_APPROVE_ITEM_REQUEST = 'CORE_APPROVE_ITEM_REQUEST'
export const CORE_APPROVE_ITEM_SUCCESS = 'CORE_APPROVE_ITEM_SUCCESS'
export const CORE_APPROVE_ITEM_FAILURE = 'CORE_APPROVE_ITEM_FAILURE'

export const CORE_GEN_CODE_ITEM_REQUEST = 'CORE_GEN_CODE_ITEM_REQUEST'
export const CORE_GEN_CODE_ITEM_SUCCESS = 'CORE_GEN_CODE_ITEM_SUCCESS'
export const CORE_GEN_CODE_ITEM_FAILURE = 'CORE_GEN_CODE_ITEM_FAILURE'

export const CORE_RE_SEND_ITEM_REQUEST = 'CORE_RE_SEND_ITEM_REQUEST'
export const CORE_RE_SEND_ITEM_SUCCESS = 'CORE_RE_SEND_ITEM_SUCCESS'
export const CORE_RE_SEND_ITEM_FAILURE = 'CORE_RE_SEND_ITEM_FAILURE'

// Item Confirm
export const CORE_CREATE_DRAWING_CONFIRM_REQUEST = 'CORE_CREATE_DRAWING_CONFIRM_REQUEST'
export const CORE_CREATE_DRAWING_CONFIRM_SUCCESS = 'CORE_CREATE_DRAWING_CONFIRM_SUCCESS'
export const CORE_CREATE_DRAWING_CONFIRM_FAILURE = 'CORE_CREATE_DRAWING_CONFIRM_FAILURE'

//Item Delete
export const CORE_DELETE_DRAWING_REQUEST = 'CORE_DELETE_DRAWING_REQUEST'
export const CORE_DELETE_DRAWING_SUCCESS = 'CORE_DELETE_DRAWING_SUCCESS'
export const CORE_DELETE_DRAWING_FAILURE = 'CORE_DELETE_DRAWING_FAILURE'


// Drawing Item Information
export const CORE_CREATE_DRAWING_INFO_REQUEST = 'CORE_CREATE_DRAWING_INFO_REQUEST'
export const CORE_CREATE_DRAWING_INFO_SUCCESS = 'CORE_CREATE_DRAWING_INFO_SUCCESS'
export const CORE_CREATE_DRAWING_INFO_FAILURE = 'CORE_CREATE_DRAWING_INFO_FAILURE'

// Report
export const CORE_GET_REPORT_DRAWING_STATUS_REQUEST = "CORE_GET_REPORT_DRAWING_STATUS_REQUEST"
export const CORE_GET_REPORT_DRAWING_STATUS_SUCCESS = "CORE_GET_REPORT_DRAWING_STATUS_SUCCESS"
export const CORE_GET_REPORT_DRAWING_STATUS_FAILURE = "CORE_GET_REPORT_DRAWING_STATUS_FAILURE"

export const CORE_GET_REPORT_VIEW_DRAWING_REQUEST = "CORE_GET_REPORT_VIEW_DRAWING_REQUEST"
export const CORE_GET_REPORT_VIEW_DRAWING_SUCCESS = "CORE_GET_REPORT_VIEW_DRAWING_SUCCESS"
export const CORE_GET_REPORT_VIEW_DRAWING_FAILURE = "CORE_GET_REPORT_VIEW_DRAWING_FAILURE"

// Master Data
export const CORE_GET_TUBE_INSIDE_DATA_REQUEST = "CORE_GET_TUBE_INSIDE_DATA_REQUEST"
export const CORE_GET_TUBE_INSIDE_DATA_SUCCESS = "CORE_GET_TUBE_INSIDE_DATA_SUCCESS"
export const CORE_GET_TUBE_INSIDE_DATA_FAILURE = "CORE_GET_TUBE_INSIDE_DATA_FAILURE"

export const CORE_SEARCH_TUBE_INSIDE_DATA_REQUEST = "CORE_SEARCH_TUBE_INSIDE_DATA_REQUEST"
export const CORE_SEARCH_TUBE_INSIDE_DATA_SUCCESS = "CORE_SEARCH_TUBE_INSIDE_DATA_SUCCESS"
export const CORE_SEARCH_TUBE_INSIDE_DATA_FAILURE = "CORE_SEARCH_TUBE_INSIDE_DATA_FAILURE"

export const CORE_GET_PIPE_TYPE_DATA_REQUEST = "CORE_GET_PIPE_TYPE_DATA_REQUEST"
export const CORE_GET_PIPE_TYPE_DATA_SUCCESS = "CORE_GET_PIPE_TYPE_DATA_SUCCESS"
export const CORE_GET_PIPE_TYPE_DATA_FAILURE = "CORE_GET_PIPE_TYPE_DATA_FAILURE"

export const CORE_SEARCH_PIPE_TYPE_DATA_REQUEST = "CORE_SEARCH_PIPE_TYPE_DATA_REQUEST"
export const CORE_SEARCH_PIPE_TYPE_DATA_SUCCESS = "CORE_SEARCH_PIPE_TYPE_DATA_SUCCESS"
export const CORE_SEARCH_PIPE_TYPE_DATA_FAILURE = "CORE_SEARCH_PIPE_TYPE_DATA_FAILURE"

export const CORE_GET_FIN_EDGE_DATA_REQUEST = "CORE_GET_FIN_EDGE_DATA_REQUEST"
export const CORE_GET_FIN_EDGE_DATA_SUCCESS = "CORE_GET_FIN_EDGE_DATA_SUCCESS"
export const CORE_GET_FIN_EDGE_DATA_FAILURE = "CORE_GET_FIN_EDGE_DATA_FAILURE"

export const CORE_SEARCH_FIN_EDGE_DATA_REQUEST = "CORE_SEARCH_FIN_EDGE_DATA_REQUEST"
export const CORE_SEARCH_FIN_EDGE_DATA_SUCCESS = "CORE_SEARCH_FIN_EDGE_DATA_SUCCESS"
export const CORE_SEARCH_FIN_EDGE_DATA_FAILURE = "CORE_SEARCH_FIN_EDGE_DATA_FAILURE"

export const CORE_GET_FIN_SURFACE_DATA_REQUEST = "CORE_GET_FIN_SURFACE_DATA_REQUEST"
export const CORE_GET_FIN_SURFACE_DATA_SUCCESS = "CORE_GET_FIN_SURFACE_DATA_SUCCESS"
export const CORE_GET_FIN_SURFACE_DATA_FAILURE = "CORE_GET_FIN_SURFACE_DATA_FAILURE"

export const CORE_SEARCH_FIN_SURFACE_DATA_REQUEST = "CORE_SEARCH_FIN_SURFACE_DATA_REQUEST"
export const CORE_SEARCH_FIN_SURFACE_DATA_SUCCESS = "CORE_SEARCH_FIN_SURFACE_DATA_SUCCESS"
export const CORE_SEARCH_FIN_SURFACE_DATA_FAILURE = "CORE_SEARCH_FIN_SURFACE_DATA_FAILURE"


// Sell Order
export const CORE_LOAD_SELL_ORDER_INFORMATION_REQUEST = "CORE_LOAD_SELL_ORDER_INFORMATION_REQUEST"
export const CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS = "CORE_LOAD_SELL_ORDER_INFORMATION_SUCCESS"
export const CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE = "CORE_LOAD_SELL_ORDER_INFORMATION_FAILURE"

export const CORE_CREATE_SELL_ORDER_INFO_REQUEST = "CORE_CREATE_SELL_ORDER_INFO_REQUEST"
export const CORE_CREATE_SELL_ORDER_INFO_SUCCESS = "CORE_CREATE_SELL_ORDER_INFO_SUCCESS"
export const CORE_CREATE_SELL_ORDER_INFO_FAILURE = "CORE_CREATE_SELL_ORDER_INFO_FAILURE"

export const CORE_SEARCH_SELL_ORDER_REQUEST = "CORE_SEARCH_SELL_ORDER_REQUEST"
export const CORE_SEARCH_SELL_ORDER_SUCCESS = "CORE_SEARCH_SELL_ORDER_SUCCESS"
export const CORE_SEARCH_SELL_ORDER_FAILURE = "CORE_SEARCH_SELL_ORDER_FAILURE"

export const CORE_UPDATE_SELL_ORDER_INFO_REQUEST = "CORE_UPDATE_SELL_ORDER_INFO_REQUEST"
export const CORE_UPDATE_SELL_ORDER_INFO_SUCCESS = "CORE_UPDATE_SELL_ORDER_INFO_SUCCESS"
export const CORE_UPDATE_SELL_ORDER_INFO_FAILURE = "CORE_UPDATE_SELL_ORDER_INFO_FAILURE"

export const CORE_APPROVE_REQUEST = "CORE_APPROVE_REQUEST"
export const CORE_APPROVE_SUCCESS = "CORE_APPROVE_SUCCESS"
export const CORE_APPROVE_FAILURE = "CORE_APPROVE_FAILURE"

export const CORE_PRE_APPROVE_REQUEST = "CORE_PRE_APPROVE_REQUEST"
export const CORE_PRE_APPROVE_SUCCESS = "CORE_PRE_APPROVE_SUCCESS"
export const CORE_PRE_APPROVE_FAILURE = "CORE_PRE_APPROVE_FAILURE"

export const CORE_CUSTOMER_APPROVE_REQUEST = "CORE_CUSTOMER_APPROVE_REQUEST"
export const CORE_CUSTOMER_APPROVE_SUCCESS = "CORE_CUSTOMER_APPROVE_SUCCESS"
export const CORE_CUSTOMER_APPROVE_FAILURE = "CORE_CUSTOMER_APPROVE_FAILURE"

export const CORE_DELETE_SELL_ORDER_REQUEST = "CORE_DELETE_SELL_ORDER_REQUEST"
export const CORE_DELETE_SELL_ORDER_SUCCESS = "CORE_DELETE_SELL_ORDER_SUCCESS"
export const CORE_DELETE_SELL_ORDER_FAILURE = "CORE_DELETE_SELL_ORDER_FAILURE"

export const CORE_REJECT_SELL_ORDER_REQUEST = "CORE_REJECT_SELL_ORDER_REQUEST"
export const CORE_REJECT_SELL_ORDER_SUCCESS = "CORE_REJECT_SELL_ORDER_SUCCESS"
export const CORE_REJECT_SELL_ORDER_FAILURE = "CORE_REJECT_SELL_ORDER_FAILURE"

export const CORE_LOAD_SETTING_REQUEST = "CORE_LOAD_SETTING_REQUEST"
export const CORE_LOAD_SETTING_SUCCESS = "CORE_LOAD_SETTING_SUCCESS"
export const CORE_LOAD_SETTING_FAILURE = "CORE_LOAD_SETTING_FAILURE"

export const CORE_CHANGE_SETTING_REQUEST = "CORE_CHANGE_SETTING_REQUEST"
export const CORE_CHANGE_SETTING_SUCCESS = "CORE_CHANGE_SETTING_SUCCESS"
export const CORE_CHANGE_SETTING_FAILURE = "CORE_CHANGE_SETTING_FAILURE"

export const CORE_SUBMIT_REQUEST = "CORE_SUBMIT_REQUEST"
export const CORE_SUBMIT_SUCCESS = "CORE_SUBMIT_SUCCESS"
export const CORE_SUBMIT_FAILURE = "CORE_SUBMIT_FAILURE"

export const CORE_SHOP_SUBMIT_SELL_ORDER_REQUEST = "CORE_SHOP_SUBMIT_SELL_ORDER_REQUEST"
export const CORE_SHOP_SUBMIT_SELL_ORDER_SUCCESS = "CORE_SHOP_SUBMIT_SELL_ORDER_SUCCESS"
export const CORE_SHOP_SUBMIT_SELL_ORDER_FAILURE = "CORE_SHOP_SUBMIT_SELL_ORDER_FAILURE"

export const CORE_COMPLETE_SELL_ORDER_REQUEST = "CORE_COMPLETE_SELL_ORDER_REQUEST"
export const CORE_COMPLETE_SELL_ORDER_SUCCESS = "CORE_COMPLETE_SELL_ORDER_SUCCESS"
export const CORE_COMPLETE_SELL_ORDER_FAILURE = "CORE_COMPLETE_SELL_ORDER_FAILURE"

export const CORE_COMMENT_SELL_ORDER_REQUEST = "CORE_COMMENT_SELL_ORDER_REQUEST"
export const CORE_COMMENT_SELL_ORDER_SUCCESS = "CORE_COMMENT_SELL_ORDER_SUCCESS"
export const CORE_COMMENT_SELL_ORDER_FAILURE = "CORE_COMMENT_SELL_ORDER_FAILURE"

export const CORE_ATTACH_FILE_SELL_ORDER_REQUEST = "CORE_ATTACH_FILE_SELL_ORDER_REQUEST"
export const CORE_ATTACH_FILE_SELL_ORDER_SUCCESS = "CORE_ATTACH_FILE_SELL_ORDER_SUCCESS"
export const CORE_ATTACH_FILE_SELL_ORDER_FAILURE = "CORE_ATTACH_FILE_SELL_ORDER_FAILURE"

export const CORE_GENCODE_NPI_SELL_ORDER_REQUEST = "CORE_GENCODE_NPI_SELL_ORDER_REQUEST"
export const CORE_GENCODE_NPI_SELL_ORDER_SUCCESS = "CORE_GENCODE_NPI_SELL_ORDER_SUCCESS"
export const CORE_GENCODE_NPI_SELL_ORDER_FAILURE = "CORE_GENCODE_NPI_SELL_ORDER_FAILURE"

export const CORE_SUBMIT_DRAWING_SELL_ORDER_REQUEST = "CORE_SUBMIT_DRAWING_SELL_ORDER_REQUEST"
export const CORE_SUBMIT_DRAWING_SELL_ORDER_SUCCESS = "CORE_SUBMIT_DRAWING_SELL_ORDER_SUCCESS"
export const CORE_SUBMIT_DRAWING_SELL_ORDER_FAILURE = "CORE_SUBMIT_DRAWING_SELL_ORDER_FAILURE"

export const CORE_SHOP_APPROVE_SELL_ORDER_REQUEST = "CORE_SHOP_APPROVE_SELL_ORDER_REQUEST"
export const CORE_SHOP_APPROVE_SELL_ORDER_SUCCESS = "CORE_SHOP_APPROVE_SELL_ORDER_SUCCESS"
export const CORE_SHOP_APPROVE_SELL_ORDER_FAILURE = "CORE_SHOP_APPROVE_SELL_ORDER_FAILURE"

export const CORE_CANCEL_SELL_ORDER_REQUEST = "CORE_CANCEL_SELL_ORDER_REQUEST"
export const CORE_CANCEL_SELL_ORDER_SUCCESS = "CORE_CANCEL_SELL_ORDER_SUCCESS"
export const CORE_CANCEL_SELL_ORDER_FAILURE = "CORE_CANCEL_SELL_ORDER_FAILURE"

export const CORE_GET_REPORT_REQ_DRAWING_STATUS_REQUEST = "CORE_GET_REPORT_REQ_DRAWING_STATUS_REQUES"
export const CORE_GET_REPORT_REQ_DRAWING_STATUS_SUCCESS = "CORE_GET_REPORT_REQ_DRAWING_STATUS_SUCCES"
export const CORE_GET_REPORT_REQ_DRAWING_STATUS_FAILURE = "CORE_GET_REPORT_REQ_DRAWING_STATUS_FAILURE"

export const CORE_RE_STATUS_SELL_ORDER_REQUEST = "CORE_RE_STATUS_SELL_ORDER_REQUEST"
export const CORE_RE_STATUS_SELL_ORDER_SUCCESS = "CORE_RE_STATUS_SELL_ORDER_SUCCESS"
export const CORE_RE_STATUS_SELL_ORDER_FAILURE = "CORE_RE_STATUS_SELL_ORDER_FAILURE"

export const CORE_GET_ONEDRIVE_LINK_REQUEST = "CORE_GET_ONEDRIVE_LINK_REQUEST"
export const CORE_GET_ONEDRIVE_LINK_SUCCESS = "CORE_GET_ONEDRIVE_LINK_SUCCESS"
export const CORE_GET_ONEDRIVE_LINK_FAILURE = "CORE_GET_ONEDRIVE_LINK_FAILURE"

//Req Tube
export const CORE_GET_REQ_TUBE_ALL_TUBE_REQUEST = "CORE_GET_REQ_TUBE_ALL_TUBE_REQUEST"
export const CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS = "CORE_GET_REQ_TUBE_ALL_TUBE_SUCCESS"
export const CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE = "CORE_GET_REQ_TUBE_ALL_TUBE_FAILURE"

export const CORE_LOAD_REQ_TUBE_INFORMATION_REQUEST = "CORE_LOAD_REQ_TUBE_INFORMATION_REQUEST"
export const CORE_LOAD_REQ_TUBE_INFORMATION_SUCCESS = "CORE_LOAD_REQ_TUBE_INFORMATION_SUCCESS"
export const CORE_LOAD_REQ_TUBE_INFORMATION_FAILURE = "CORE_LOAD_REQ_TUBE_INFORMATION_FAILURE"

export const CORE_CREATE_REQ_TUBE_INFO_REQUEST = "CORE_CREATE_REQ_TUBE_INFO_REQUEST"
export const CORE_CREATE_REQ_TUBE_INFO_SUCCESS = "CORE_CREATE_REQ_TUBE_INFO_SUCCESS"
export const CORE_CREATE_REQ_TUBE_INFO_FAILURE = "CORE_CREATE_REQ_TUBE_INFO_FAILURE"

export const CORE_UPDATE_REQ_TUBE_INFO_REQUEST = "CORE_UPDATE_REQ_TUBE_INFO_REQUEST"
export const CORE_UPDATE_REQ_TUBE_INFO_SUCCESS = "CORE_UPDATE_REQ_TUBE_INFO_SUCCESS"
export const CORE_UPDATE_REQ_TUBE_INFO_FAILURE = "CORE_UPDATE_REQ_TUBE_INFO_FAILURE"

export const CORE_SEARCH_REQ_TUBE_REQUEST = "CORE_SEARCH_REQ_TUBE_REQUEST"
export const CORE_SEARCH_REQ_TUBE_SUCCESS = "CORE_SEARCH_REQ_TUBE_SUCCESS"
export const CORE_SEARCH_REQ_TUBE_FAILURE = "CORE_SEARCH_REQ_TUBE_FAILURE"

export const CORE_APPROVE_REQ_TUBE_REQUEST = "CORE_APPROVE_REQ_TUBE_REQUEST"
export const CORE_APPROVE_REQ_TUBE_SUCCESS = "CORE_APPROVE_REQ_TUBE_SUCCESS"
export const CORE_APPROVE_REQ_TUBE_FAILURE = "CORE_APPROVE_REQ_TUBE_FAILURE"

export const CORE_PRE_APPROVE_REQ_TUBE_REQUEST = "CORE_PRE_APPROVE_REQ_TUBE_REQUEST"
export const CORE_PRE_APPROVE_REQ_TUBE_SUCCESS = "CORE_PRE_APPROVE_REQ_TUBE_SUCCESS"
export const CORE_PRE_APPROVE_REQ_TUBE_FAILURE = "CORE_PRE_APPROVE_REQ_TUBE_FAILURE"

export const CORE_CUSTOMER_APPROVE_REQ_TUBE_REQUEST = "CORE_CUSTOMER_APPROVE_REQ_TUBE_REQUEST"
export const CORE_CUSTOMER_APPROVE_REQ_TUBE_SUCCESS = "CORE_CUSTOMER_APPROVE_REQ_TUBE_SUCCESS"
export const CORE_CUSTOMER_APPROVE_REQ_TUBE_FAILURE = "CORE_CUSTOMER_APPROVE_REQ_TUBE_FAILURE"

export const CORE_REJECT_REQ_TUBE_REQUEST = "CORE_REJECT_REQ_TUBE_REQUEST"
export const CORE_REJECT_REQ_TUBE_SUCCESS = "CORE_REJECT_REQ_TUBE_SUCCESS"
export const CORE_REJECT_REQ_TUBE_FAILURE = "CORE_REJECT_REQ_TUBE_FAILURE"

export const CORE_DELETE_REQ_TUBE_REQUEST = "CORE_DELETE_REQ_TUBE_REQUEST"
export const CORE_DELETE_REQ_TUBE_SUCCESS = "CORE_DELETE_REQ_TUBE_SUCCESS"
export const CORE_DELETE_REQ_TUBE_FAILURE = "CORE_DELETE_REQ_TUBE_FAILURE"

export const CORE_SUBMIT_REQ_TUBE_REQUEST = "CORE_SUBMIT_REQ_TUBE_REQUEST"
export const CORE_SUBMIT_REQ_TUBE_SUCCESS = "CORE_SUBMIT_REQ_TUBE_SUCCESS"
export const CORE_SUBMIT_REQ_TUBE_FAILURE = "CORE_SUBMIT_REQ_TUBE_FAILURE"

export const CORE_SHOP_SUBMIT_REQ_TUBE_REQUEST = "CORE_SHOP_SUBMIT_REQ_TUBE_REQUEST"
export const CORE_SHOP_SUBMIT_REQ_TUBE_SUCCESS = "CORE_SHOP_SUBMIT_REQ_TUBE_SUCCESS"
export const CORE_SHOP_SUBMIT_REQ_TUBE_FAILURE = "CORE_SHOP_SUBMIT_REQ_TUBE_FAILURE"

export const CORE_COMPLETE_REQ_TUBE_REQUEST = "CORE_COMPLETE_REQ_TUBE_REQUEST"
export const CORE_COMPLETE_REQ_TUBE_SUCCESS = "CORE_COMPLETE_REQ_TUBE_SUCCESS"
export const CORE_COMPLETE_REQ_TUBE_FAILURE = "CORE_COMPLETE_REQ_TUBE_FAILURE"

export const CORE_COMMENT_REQ_TUBE_REQUEST = "CORE_COMMENT_REQ_TUBE_REQUEST"
export const CORE_COMMENT_REQ_TUBE_SUCCESS = "CORE_COMMENT_REQ_TUBE_SUCCESS"
export const CORE_COMMENT_REQ_TUBE_FAILURE = "CORE_COMMENT_REQ_TUBE_FAILURE"

export const CORE_ATTACH_FILE_REQ_TUBE_REQUEST = "CORE_ATTACH_FILE_REQ_TUBE_REQUEST"
export const CORE_ATTACH_FILE_REQ_TUBE_SUCCESS = "CORE_ATTACH_FILE_REQ_TUBE_SUCCESS"
export const CORE_ATTACH_FILE_REQ_TUBE_FAILURE = "CORE_ATTACH_FILE_REQ_TUBE_FAILURE"

export const CORE_GENCODE_NPI_REQ_TUBE_REQUEST = "CORE_GENCODE_NPI_REQ_TUBE_REQUEST"
export const CORE_GENCODE_NPI_REQ_TUBE_SUCCESS = "CORE_GENCODE_NPI_REQ_TUBE_SUCCESS"
export const CORE_GENCODE_NPI_REQ_TUBE_FAILURE = "CORE_GENCODE_NPI_REQ_TUBE_FAILURE"

export const CORE_SUBMIT_DRAWING_REQ_TUBE_REQUEST = "CORE_SUBMIT_DRAWING_REQ_TUBE_REQUEST"
export const CORE_SUBMIT_DRAWING_REQ_TUBE_SUCCESS = "CORE_SUBMIT_DRAWING_REQ_TUBE_SUCCESS"
export const CORE_SUBMIT_DRAWING_REQ_TUBE_FAILURE = "CORE_SUBMIT_DRAWING_REQ_TUBE_FAILURE"

export const CORE_SHOP_APPROVE_REQ_TUBE_REQUEST = "CORE_SHOP_APPROVE_REQ_TUBE_REQUEST"
export const CORE_SHOP_APPROVE_REQ_TUBE_SUCCESS = "CORE_SHOP_APPROVE_REQ_TUBE_SUCCESS"
export const CORE_SHOP_APPROVE_REQ_TUBE_FAILURE = "CORE_SHOP_APPROVE_REQ_TUBE_FAILURE"

export const CORE_CANCEL_REQ_TUBE_REQUEST = "CORE_CANCEL_REQ_TUBE_REQUEST"
export const CORE_CANCEL_REQ_TUBE_SUCCESS = "CORE_CANCEL_REQ_TUBE_SUCCESS"
export const CORE_CANCEL_REQ_TUBE_FAILURE = "CORE_CANCEL_REQ_TUBE_FAILURE"

export const CORE_RE_STATUS_REQ_TUBE_REQUEST = "CORE_RE_STATUS_REQ_TUBE_REQUEST"
export const CORE_RE_STATUS_REQ_TUBE_SUCCESS = "CORE_RE_STATUS_REQ_TUBE_SUCCESS"
export const CORE_RE_STATUS_REQ_TUBE_FAILURE = "CORE_RE_STATUS_REQ_TUBE_FAILURE"

export const CORE_GET_ONEDRIVE_LINK_REQ_TUBE_REQUEST = "CORE_GET_ONEDRIVE_LINK_REQ_TUBE_REQUEST"
export const CORE_GET_ONEDRIVE_LINK_REQ_TUBE_SUCCESS = "CORE_GET_ONEDRIVE_LINK_REQ_TUBE_SUCCESS"
export const CORE_GET_ONEDRIVE_LINK_REQ_TUBE_FAILURE = "CORE_GET_ONEDRIVE_LINK_REQ_TUBE_FAILURE"


export const CORE_GET_SYSTEM_INFO_REQUEST = "CORE_GET_SYSTEM_INFO_REQUEST"
export const CORE_GET_SYSTEM_INFO_SUCCESS = "CORE_GET_SYSTEM_INFO_SUCCESS"
export const CORE_GET_SYSTEM_INFO_FAILURE = "CORE_GET_SYSTEM_INFO_FAILURE"


// Req Acc
export const CORE_LOAD_REQ_ACC_INFORMATION_REQUEST = "CORE_LOAD_REQ_ACC_INFORMATION_REQUEST"
export const CORE_LOAD_REQ_ACC_INFORMATION_SUCCESS = "CORE_LOAD_REQ_ACC_INFORMATION_SUCCESS"
export const CORE_LOAD_REQ_ACC_INFORMATION_FAILURE = "CORE_LOAD_REQ_ACC_INFORMATION_FAILURE"

export const CORE_CREATE_REQ_ACC_INFO_REQUEST = "CORE_CREATE_REQ_ACC_INFO_REQUEST"
export const CORE_CREATE_REQ_ACC_INFO_SUCCESS = "CORE_CREATE_REQ_ACC_INFO_SUCCESS"
export const CORE_CREATE_REQ_ACC_INFO_FAILURE = "CORE_CREATE_REQ_ACC_INFO_FAILURE"

export const CORE_UPDATE_REQ_ACC_INFO_REQUEST = "CORE_UPDATE_REQ_ACC_INFO_REQUEST"
export const CORE_UPDATE_REQ_ACC_INFO_SUCCESS = "CORE_UPDATE_REQ_ACC_INFO_SUCCESS"
export const CORE_UPDATE_REQ_ACC_INFO_FAILURE = "CORE_UPDATE_REQ_ACC_INFO_FAILURE"

export const CORE_SEARCH_REQ_ACC_REQUEST = "CORE_SEARCH_REQ_ACC_REQUEST"
export const CORE_SEARCH_REQ_ACC_SUCCESS = "CORE_SEARCH_REQ_ACC_SUCCESS"
export const CORE_SEARCH_REQ_ACC_FAILURE = "CORE_SEARCH_REQ_ACC_FAILURE"

export const CORE_APPROVE_REQ_ACC_REQUEST = "CORE_APPROVE_REQ_ACC_REQUEST"
export const CORE_APPROVE_REQ_ACC_SUCCESS = "CORE_APPROVE_REQ_ACC_SUCCESS"
export const CORE_APPROVE_REQ_ACC_FAILURE = "CORE_APPROVE_REQ_ACC_FAILURE"

export const CORE_PRE_APPROVE_REQ_ACC_REQUEST = "CORE_PRE_APPROVE_REQ_ACC_REQUEST"
export const CORE_PRE_APPROVE_REQ_ACC_SUCCESS = "CORE_PRE_APPROVE_REQ_ACC_SUCCESS"
export const CORE_PRE_APPROVE_REQ_ACC_FAILURE = "CORE_PRE_APPROVE_REQ_ACC_FAILURE"

export const CORE_CUSTOMER_APPROVE_REQ_ACC_REQUEST = "CORE_CUSTOMER_APPROVE_REQ_ACC_REQUEST"
export const CORE_CUSTOMER_APPROVE_REQ_ACC_SUCCESS = "CORE_CUSTOMER_APPROVE_REQ_ACC_SUCCESS"
export const CORE_CUSTOMER_APPROVE_REQ_ACC_FAILURE = "CORE_CUSTOMER_APPROVE_REQ_ACC_FAILURE"

export const CORE_REJECT_REQ_ACC_REQUEST = "CORE_REJECT_REQ_ACC_REQUEST"
export const CORE_REJECT_REQ_ACC_SUCCESS = "CORE_REJECT_REQ_ACC_SUCCESS"
export const CORE_REJECT_REQ_ACC_FAILURE = "CORE_REJECT_REQ_ACC_FAILURE"

export const CORE_DELETE_REQ_ACC_REQUEST = "CORE_DELETE_REQ_ACC_REQUEST"
export const CORE_DELETE_REQ_ACC_SUCCESS = "CORE_DELETE_REQ_ACC_SUCCESS"
export const CORE_DELETE_REQ_ACC_FAILURE = "CORE_DELETE_REQ_ACC_FAILURE"

export const CORE_SUBMIT_REQ_ACC_REQUEST = "CORE_SUBMIT_REQ_ACC_REQUEST"
export const CORE_SUBMIT_REQ_ACC_SUCCESS = "CORE_SUBMIT_REQ_ACC_SUCCESS"
export const CORE_SUBMIT_REQ_ACC_FAILURE = "CORE_SUBMIT_REQ_ACC_FAILURE"

export const CORE_SHOP_SUBMIT_REQ_ACC_REQUEST = "CORE_SHOP_SUBMIT_REQ_ACC_REQUEST"
export const CORE_SHOP_SUBMIT_REQ_ACC_SUCCESS = "CORE_SHOP_SUBMIT_REQ_ACC_SUCCESS"
export const CORE_SHOP_SUBMIT_REQ_ACC_FAILURE = "CORE_SHOP_SUBMIT_REQ_ACC_FAILURE"

export const CORE_COMPLETE_REQ_ACC_REQUEST = "CORE_COMPLETE_REQ_ACC_REQUEST"
export const CORE_COMPLETE_REQ_ACC_SUCCESS = "CORE_COMPLETE_REQ_ACC_SUCCESS"
export const CORE_COMPLETE_REQ_ACC_FAILURE = "CORE_COMPLETE_REQ_ACC_FAILURE"

export const CORE_COMMENT_REQ_ACC_REQUEST = "CORE_COMMENT_REQ_ACC_REQUEST"
export const CORE_COMMENT_REQ_ACC_SUCCESS = "CORE_COMMENT_REQ_ACC_SUCCESS"
export const CORE_COMMENT_REQ_ACC_FAILURE = "CORE_COMMENT_REQ_ACC_FAILURE"

export const CORE_ATTACH_FILE_REQ_ACC_REQUEST = "CORE_ATTACH_FILE_REQ_ACC_REQUEST"
export const CORE_ATTACH_FILE_REQ_ACC_SUCCESS = "CORE_ATTACH_FILE_REQ_ACC_SUCCESS"
export const CORE_ATTACH_FILE_REQ_ACC_FAILURE = "CORE_ATTACH_FILE_REQ_ACC_FAILURE"

export const CORE_GENCODE_NPI_REQ_ACC_REQUEST = "CORE_GENCODE_NPI_REQ_ACC_REQUEST"
export const CORE_GENCODE_NPI_REQ_ACC_SUCCESS = "CORE_GENCODE_NPI_REQ_ACC_SUCCESS"
export const CORE_GENCODE_NPI_REQ_ACC_FAILURE = "CORE_GENCODE_NPI_REQ_ACC_FAILURE"

export const CORE_SUBMIT_DRAWING_REQ_ACC_REQUEST = "CORE_SUBMIT_DRAWING_REQ_ACC_REQUEST"
export const CORE_SUBMIT_DRAWING_REQ_ACC_SUCCESS = "CORE_SUBMIT_DRAWING_REQ_ACC_SUCCESS"
export const CORE_SUBMIT_DRAWING_REQ_ACC_FAILURE = "CORE_SUBMIT_DRAWING_REQ_ACC_FAILURE"

export const CORE_SHOP_APPROVE_REQ_ACC_REQUEST = "CORE_SHOP_APPROVE_REQ_ACC_REQUEST"
export const CORE_SHOP_APPROVE_REQ_ACC_SUCCESS = "CORE_SHOP_APPROVE_REQ_ACC_SUCCESS"
export const CORE_SHOP_APPROVE_REQ_ACC_FAILURE = "CORE_SHOP_APPROVE_REQ_ACC_FAILURE"

export const CORE_CANCEL_REQ_ACC_REQUEST = "CORE_CANCEL_REQ_ACC_REQUEST"
export const CORE_CANCEL_REQ_ACC_SUCCESS = "CORE_CANCEL_REQ_ACC_SUCCESS"
export const CORE_CANCEL_REQ_ACC_FAILURE = "CORE_CANCEL_REQ_ACC_FAILURE"

export const CORE_RE_STATUS_REQ_ACC_REQUEST = "CORE_RE_STATUS_REQ_ACC_REQUEST"
export const CORE_RE_STATUS_REQ_ACC_SUCCESS = "CORE_RE_STATUS_REQ_ACC_SUCCESS"
export const CORE_RE_STATUS_REQ_ACC_FAILURE = "CORE_RE_STATUS_REQ_ACC_FAILURE"

export const CORE_GET_ONEDRIVE_LINK_REQ_ACC_REQUEST = "CORE_GET_ONEDRIVE_LINK_REQ_ACC_REQUEST"
export const CORE_GET_ONEDRIVE_LINK_REQ_ACC_SUCCESS = "CORE_GET_ONEDRIVE_LINK_REQ_ACC_SUCCESS"
export const CORE_GET_ONEDRIVE_LINK_REQ_ACC_FAILURE = "CORE_GET_ONEDRIVE_LINK_REQ_ACC_FAILURE"

export const CORE_GET_REQ_ACC_ALL_TUBE_REQUEST = "CORE_GET_REQ_ACC_ALL_TUBE_REQUEST"
export const CORE_GET_REQ_ACC_ALL_TUBE_SUCCESS = "CORE_GET_REQ_ACC_ALL_TUBE_SUCCESS"
export const CORE_GET_REQ_ACC_ALL_TUBE_FAILURE = "CORE_GET_REQ_ACC_ALL_TUBE_FAILURE"

export const CORE_GET_DOWNLOAD_DRAWING_FILE_REQUEST = "CORE_GET_DOWNLOAD_DRAWING_FILE_REQUEST"
export const CORE_GET_DOWNLOAD_DRAWING_FILE_SUCCESS = "CORE_GET_DOWNLOAD_DRAWING_FILE_SUCCESS"
export const CORE_GET_DOWNLOAD_DRAWING_FILE_FAILURE = "CORE_GET_DOWNLOAD_DRAWING_FILE_FAILURE"

export const CORE_GET_REPORT_FOLLOW_STATUS_REQUEST = "CORE_GET_REPORT_FOLLOW_STATUS_REQUEST"
export const CORE_GET_REPORT_FOLLOW_STATUS_SUCCESS = "CORE_GET_REPORT_FOLLOW_STATUS_SUCCESS"
export const CORE_GET_REPORT_FOLLOW_STATUS_FAILURE = "CORE_GET_REPORT_FOLLOW_STATUS_FAILURE"


export const CORE_GET_REPORT_SUMMARY_STATUS_REQUEST = "CORE_GET_REPORT_SUMMARY_STATUS_REQUEST"
export const CORE_GET_REPORT_SUMMARY_STATUS_SUCCESS = "CORE_GET_REPORT_SUMMARY_STATUS_SUCCESS"
export const CORE_GET_REPORT_SUMMARY_STATUS_FAILURE = "CORE_GET_REPORT_SUMMARY_STATUS_FAILURE"

export const CORE_UPDATE_DESIGN_PLAN_COIL_REQUEST = "CORE_UPDATE_DESIGN_PLAN_COIL_REQUEST"
export const CORE_UPDATE_DESIGN_PLAN_COIL_SUCCESS = "CORE_UPDATE_DESIGN_PLAN_COIL_SUCCESS"
export const CORE_UPDATE_DESIGN_PLAN_COIL_FAILURE = "CORE_UPDATE_DESIGN_PLAN_COIL_FAILURE"

export const CORE_UPDATE_DESIGN_PLAN_TUBE_REQUEST = "CORE_UPDATE_DESIGN_PLAN_TUBE_REQUEST"
export const CORE_UPDATE_DESIGN_PLAN_TUBE_SUCCESS = "CORE_UPDATE_DESIGN_PLAN_TUBE_SUCCESS"
export const CORE_UPDATE_DESIGN_PLAN_TUBE_FAILURE = "CORE_UPDATE_DESIGN_PLAN_TUBE_FAILURE"

export const CORE_UPDATE_DESIGN_PLAN_ACC_REQUEST = "CORE_UPDATE_DESIGN_PLAN_ACC_REQUEST"
export const CORE_UPDATE_DESIGN_PLAN_ACC_SUCCESS = "CORE_UPDATE_DESIGN_PLAN_ACC_SUCCESS"
export const CORE_UPDATE_DESIGN_PLAN_ACC_FAILURE = "CORE_UPDATE_DESIGN_PLAN_ACC_FAILURE"

export const CORE_LOAD_LIST_SEARCH_ONEDRIVE_REQUEST = "CORE_LOAD_LIST_SEARCH_ONEDRIVE_REQUEST"
export const CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS = "CORE_LOAD_LIST_SEARCH_ONEDRIVE_SUCCESS"
export const CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE = "CORE_LOAD_LIST_SEARCH_ONEDRIVE_FAILURE"

export const CORE_DOWNLOAD_FILE_ONEDRIVE_REQUEST = "CORE_DOWNLOAD_FILE_ONEDRIVE_REQUEST"
export const CORE_DOWNLOAD_FILE_ONEDRIVE_SUCCESS = "CORE_DOWNLOAD_FILE_ONEDRIVE_SUCCESS"
export const CORE_DOWNLOAD_FILE_ONEDRIVE_FAILURE = "CORE_DOWNLOAD_FILE_ONEDRIVE_FAILURE"



// WEBPACK FOOTER //
// ./src/app/redux/types.js